const CORE_GROUP = 'core';

// Empty tracking groups = null = every group fires. A configured list gates
// PostHog to those groups, always including the shared `core` group so page
// view and time-on-page events keep firing.
export const resolveEnabledGroups = (trackingGroups?: string): string[] | null => {
    if (!trackingGroups) return null;

    const groups = trackingGroups.split(',').map((group) => group.trim()).filter(Boolean);

    if (groups.length === 0) return null;

    return Array.from(new Set([...groups, CORE_GROUP]));
};
